import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const allProductsStyle = StyleSheet.create({
    keyBoardView: {
        backgroundColor: appColors.light,
        alignContent: 'center',
        borderColor: appColors.light
    },
    containerView: {
        backgroundColor: appColors.lightBackgroundColor, borderColor: appColors.light
    },
    createBrandView: {
        flexDirection: "row", justifyContent: "space-between", height: 30, marginHorizontal: 20
    },
    createBrandStyle: {
        alignItems: 'flex-start', fontSize: fontSize.largerFontSize, fontFamily: appFonts.bold, color: appColors.lightDark
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 13
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    iconTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    cardContainer: {
        flex: 1,
        borderRadius: 8,
        marginBottom: 5
    },
    nameViewStyle: {
        paddingHorizontal: 10,
        flex: 0.9,
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.lightDark,
    },
    containerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
        marginVertical: 15
    },
    actionViewStyle: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        flex: 0.15
    },
    priceView: {
        justifyContent: 'center',
        alignSelf: 'flex-end',
        margin: 10
    },
    actionView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        flex: 0.15,
    },
    iconBorderStyle: {
        borderWidth: 1,
        borderRadius: 11,
        width: 40,
        height: 40,
        margin: 3,
        padding: 3,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
    filterHeaderStyle: { flexDirection: 'row', marginVertical: 5, justifyContent: 'flex-end' },
    filterContainer: { marginVertical: 10, marginHorizontal: 15, borderRadius: 16 },
    textStyle1: {
        fontSize: fontSize.smallFontSize, fontFamily: appFonts.bold, paddingHorizontal: 5,
    },
    filterFooterStyle: {
        flexDirection: 'row', marginVertical: 5, marginHorizontal: 10, justifyContent: "space-between", alignSelf: 'flex-end', zIndex: -1
    },
    buttonStyle: { width: 100, borderRadius: 7, backgroundColor: appColors.light, borderColor: appColors.primary, },
    titleStyle: { color: appColors.primary, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize },
    listContainer: {
        flexDirection: 'row', flex: 1,
        borderRadius: 8,
        marginHorizontal: 20,
        marginVertical: 10,
        padding: 20,
        backgroundColor: appColors.light
    }

})